import React from 'react';

import LoadingIndicator from '../LoadingIndicator';

interface LoadingButtonProps {
  readonly className?: string;
}

function LoadingButton(props: LoadingButtonProps) {
  return (
    <a href="#" className={`${props.className} btn btn--loading`}>
      <LoadingIndicator />
    </a>
  );
}

export default LoadingButton;
